"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const react_1 = __importDefault(require("react"));
const React = typeof window !== `undefined` && window.React ? window.React : react_1.default;
class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        const { onError, endpoint } = this.props;
        if (typeof onError === `function`) {
            try {
                onError.call(this, error, info.componentStack);
            }
            catch (_a) { } // eslint-disable-line
        }
        if (window.newrelic) {
            window.newrelic.noticeError(error, { endpoint });
        }
    }
    render() {
        const { children, fallback: Fallback = null } = this.props;
        const { error } = this.state;
        if (!error) {
            return React.createElement(React.Fragment, null, children !== null && children !== void 0 ? children : null);
        }
        if (Fallback) {
            return React.createElement(Fallback, null);
        }
        return null;
    }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=Boundary.js.map